{
  "panel": {
    "title": "Nota",
    "newNote_title": "Nota baharu",
    "search_placeholder": "Cari nota…",
    "search_aria": "Cari nota",
    "clearSearch_aria": "Kosongkan carian",
    "editorPlaceholder": "Apa yang ada di fikiran anda…",
    "titleInput_placeholder": "Tiada Tajuk",
    "untitled": "Tanpa tajuk",
    "emptyNote": "Nota kosong",
    "loadingNotes": "Memuatkan nota…",
    "noNotesYet": "Belum ada nota. Ketik + untuk mencipta satu.",
    "noResults": "Tiada hasil untuk \"{{query}}\"",
    "noNotesTagged": "Tiada nota bertanda {{tag}}",
    "tagFilterAll": "Semua",
    "filterByTag_aria": "Tapis mengikut tanda",
    "templates": "Templat",
    "editorTheme_aria": "Tema penyunting",
    "themeActive_aria": "Tema {{theme}} (aktif)",
    "theme_aria": "Tema {{theme}}",
    "themeName": {
      "dark": "Gelap",
      "sepia": "Sepia",
      "light": "Cerah",
      "forest": "Hutan"
    },
    "voice": "Suara",
    "voice_title": "Nota suara",
    "voiceUnavailable_title": "Pertuturan tidak tersedia dalam pelayar ini",
    "openVoiceRecorder_aria": "Buka perakam nota suara",
    "summarizing_title": "Meringkaskan…",
    "summarize_title": "Ringkaskan",
    "summarizeNote_aria": "Ringkaskan nota",
    "aiCommands_title": "Arahan AI  Cmd+K",
    "openAiPalette_aria": "Buka palet arahan AI",
    "enterFocusMode_title": "Mod fokus  Cmd+Shift+F",
    "exitFocusMode_title": "Keluar mod fokus  Cmd+Shift+F",
    "enterFocusMode_aria": "Masuk mod fokus",
    "exitFocusMode_aria": "Keluar mod fokus",
    "export_title": "Eksport nota",
    "delete_title": "Padam nota",
    "delete_aria": "Padam nota",
    "moreActions_title": "Lagi tindakan",
    "wordCount_one": "{{formatted}} perkataan · ~{{minutes}} min bacaan",
    "wordCount_other": "{{formatted}} perkataan · ~{{minutes}} min bacaan",
    "referencedBy_one": "Dirujuk oleh {{count}}",
    "referencedBy_other": "Dirujuk oleh {{count}}",
    "noMatchingNotes": "Tiada nota sepadan",
    "mobileTabs_aria": "Paparan nota",
    "mobileTabNotes": "Nota",
    "mobileTabEditor": "Penyunting",
    "saveFailed": "Gagal menyimpan nota: {{message}}",
    "deleteFailed": "Gagal memadam nota",
    "loadFailed": "Gagal memuatkan nota",
    "analyzeFailed": "Gagal menganalisis nota",
    "aiCommandFailed": "Arahan AI gagal",
    "unknownError": "Ralat tidak diketahui"
  },
  "paywall": {
    "title": "Nota ialah sebahagian daripada Rhemn Pro",
    "safariBody": "Unlock synced notes, dictation, and AI summaries with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "body": "Buka nota yang disegerakkan, imlak berasaskan pelayar, dan ringkasan AI berstruktur."
  },
  "format": {
    "bold": "Tebal",
    "italic": "Condong",
    "strikethrough": "Garis lorek",
    "inlineCode": "Kod sebaris",
    "heading1": "Tajuk 1",
    "heading2": "Tajuk 2",
    "heading3": "Tajuk 3",
    "bulletList": "Senarai berbutir",
    "numberedList": "Senarai bernombor",
    "blockquote": "Petikan blok",
    "codeBlock": "Blok kod",
    "toggleBold_aria": "Togol tebal",
    "toggleItalic_aria": "Togol condong",
    "toggleStrikethrough_aria": "Togol garis lorek",
    "toggleInlineCode_aria": "Togol kod sebaris",
    "toggleBulletList_aria": "Togol senarai berbutir",
    "toggleNumberedList_aria": "Togol senarai bernombor",
    "toggleBlockquote_aria": "Togol petikan blok",
    "formatOptions_aria": "Pilihan format"
  },
  "analysis": {
    "heading": "Ringkasan",
    "onDevice": "⚡ Pada peranti",
    "onDevice_aria": "Diproses pada peranti",
    "applyToNote_title": "Gunakan pada nota",
    "applyToNote_aria": "Gunakan ringkasan pada nota",
    "summaryLabel": "Ringkasan",
    "keyPointsLabel": "Perkara Utama",
    "noKeyPoints": "Tiada perkara utama dikembalikan untuk nota ini."
  },
  "export": {
    "markdown": "Eksport sebagai Markdown",
    "plainText": "Eksport sebagai Teks Biasa",
    "pdf": "Eksport sebagai PDF",
    "allZip": "Eksport semua sebagai ZIP",
    "label": "Eksport"
  },
  "cmdk": {
    "dialog_aria": "Palet arahan AI",
    "input_placeholder": "Tanya AI atau jalankan arahan…",
    "esc": "Esc",
    "back_aria": "Kembali",
    "translateTo": "Terjemah ke",
    "language_placeholder": "Bahasa…",
    "aiActions": "Tindakan AI",
    "noCommandsMatch": "Tiada arahan sepadan dengan \"{{query}}\"",
    "continue": {
      "label": "Teruskan menulis",
      "description": "Sambung dari tempat anda berhenti"
    },
    "summarize": {
      "label": "Ringkaskan pilihan",
      "description": "Padatkan kepada perkara utama"
    },
    "formal": {
      "label": "Jadikan ini formal",
      "description": "Tingkatkan nada ke profesional"
    },
    "simplify": {
      "label": "Permudahkan",
      "description": "Bahasa lebih ringkas dan jelas"
    },
    "translate": {
      "label": "Terjemah ke…",
      "description": "Terjemah ke bahasa lain"
    },
    "expand": {
      "label": "Kembangkan butir ini",
      "description": "Kembangkan butir terpilih menjadi prosa"
    },
    "languages": {
      "Spanish": "Sepanyol",
      "Arabic": "Arab",
      "French": "Perancis",
      "German": "Jerman",
      "Japanese": "Jepun",
      "Portuguese": "Portugis"
    }
  },
  "templates": {
    "dialog_aria": "Pilih templat",
    "header": "Pilih Templat",
    "builtInLabel": "Terbina dalam",
    "myTemplatesLabel": "Templat Saya",
    "saveCurrent": "Simpan nota semasa sebagai templat",
    "myTemplatesEmpty": "Templat yang anda simpan akan muncul di sini",
    "useTemplate": "Guna Templat",
    "meeting": {
      "name": "Nota Mesyuarat",
      "description": "Rakam keputusan dan tindakan",
      "structure": "Hadirin / Agenda / Nota / Tindakan"
    },
    "journal": {
      "name": "Jurnal Harian",
      "description": "Renung kembali hari anda",
      "structure": "Kesyukuran / Kemenangan hari ini / Nota"
    },
    "book": {
      "name": "Ringkasan Buku",
      "description": "Rakam idea utama daripada sebuah buku",
      "structure": "Idea teras / Petikan utama / Pengajaran"
    },
    "project": {
      "name": "Ringkasan Projek",
      "description": "Gariskan skop, matlamat, dan pihak berkepentingan",
      "structure": "Matlamat / Skop / Risiko / Garis masa"
    },
    "brainstorm": {
      "name": "Sumbang Saran",
      "description": "Rakaman idea bebas bentuk",
      "structure": "Topik / Idea / Langkah seterusnya"
    },
    "weekly": {
      "name": "Semakan Mingguan",
      "description": "Semak dan rancang minggu anda",
      "structure": "Kemenangan / Cabaran / Tumpuan"
    }
  },
  "voice": {
    "dialog_aria": "Perakam nota suara",
    "cancel_aria": "Batal",
    "statusRecording": "Merakam",
    "statusTranscribing": "Menyalin…",
    "statusReview": "Semak",
    "skip": "Langkau",
    "mark": "Tanda",
    "mark_title": "Letak penanda cap masa",
    "captureMeeting": "Rakam mesyuarat",
    "captureMeeting_title": "Turut rakam audio daripada tab mesyuarat",
    "meeting": "Mesyuarat",
    "meeting_title": "Merakam tab mesyuarat",
    "markers_aria": "Penanda cap masa",
    "listening": "Mendengar…",
    "micDenied": "Akses mikrofon dimatikan. Benarkan dalam Tetapan, kemudian cuba lagi.",
    "captureFailed": "Rakaman tidak dapat dimulakan. Cuba lagi sebentar nanti.",
    "tabPicker_aria": "Pilih tab mesyuarat untuk dirakam",
    "captureFrom": "Rakam audio daripada…",
    "noAudibleTab": "Tiada tab sedang memainkan audio. Buka mesyuarat anda dan pastikan seseorang sedang bercakap, kemudian cuba lagi.",
    "tabPickerCancel": "Batal",
    "tabTranscript": "Transkrip",
    "structuring": "Menstruktur…",
    "structuredNote": "Nota Berstruktur",
    "structureFailed": "Nota berstruktur gagal dibuat.",
    "retryStructure": "Cuba lagi",
    "browserTranscript": "Transkrip pelayar",
    "nothingCaptured": "Tiada apa-apa yang dirakam.",
    "buildingStructured": "Membina nota berstruktur…",
    "cancel": "Batal",
    "stop": "Henti",
    "recordAgain": "Rakam semula",
    "saveToNote": "Simpan ke Nota",
    "statusMeeting": "Mesyuarat",
    "captureStrip_aria": "Menangkap audio daripada {{tab}}",
    "stopCapture": "Henti tangkapan",
    "stopCapture_title": "Berhenti menangkap tab — mikrofon terus merakam",
    "stopsIn": "Berhenti dalam {{time}}",
    "autoStopped": "Rakaman berhenti pada had 60 minit.",
    "autoStoppedQuota": "Rakaman berhenti — minit transkripsi bulan ini telah digunakan.",
    "captureLost": "Tab mesyuarat ditutup. Mikrofon anda masih merakam.",
    "tabSummary": "Ringkasan",
    "noSpeakers": "Penutur tidak dikenal pasti",
    "speakerN": "Penutur {{number}}",
    "renameSpeaker_aria": "Namakan semula {{name}} — terpakai pada semua barisnya",
    "renameSpeaker_input_aria": "Nama penutur",
    "turnTime_title": "Diucapkan pada {{time}}",
    "actionItemsTitle": "Item Tindakan",
    "actionsCount": "{{checked}} daripada {{total}}",
    "addToTasks_other": "Tambah {{count}} ke Tugasan",
    "addToTasksZero": "Tambah ke Tugasan",
    "adding": "Menambah…",
    "tasksAdded_other": "{{count}} tugasan ditambah",
    "viewTasks": "Lihat",
    "addFailed": "Tidak dapat menambah — cuba lagi.",
    "minutesLeft_other": "{{count}} minit lagi",
    "minutesLeftShort_other": "{{count}} minit lagi",
    "minutesLeft_title": "{{count}} minit transkripsi berbaki bulan ini",
    "quotaExhausted": "Minit mesyuarat bulan ini telah digunakan. Diperbaharui pada {{date}}.",
    "quotaUnknown": "Baki minit tidak diketahui — rakaman mungkin mencapai had bulanan anda",
    "meetingProRequired": "Transkripsi mesyuarat sebahagian daripada Pro. Transkrip langsung anda disimpan di bawah.",
    "gateTitle": "Rakaman mesyuarat",
    "gateBody": "Rakam tab mesyuarat bersama mikrofon anda — penutur dikenal pasti dan item tindakan diekstrak. Termasuk dengan Pro.",
    "gateLater": "Bukan sekarang",
    "gateCta": "Lihat Pro",
    "roomOption": "Tiada tab — rakam bilik",
    "roomHint": "Panggilan pada pembesar suara, aplikasi asli, atau orang di dalam bilik — apa sahaja yang anda boleh dengar dengan jelas.",
    "roomHint_title": "Jika pihak satu lagi berada dalam fon kepala anda, mikrofon tidak dapat mendengarnya — gunakan pembesar suara.",
    "recordRoom": "Rakam bilik",
    "recordRoom_title": "Rakam semua yang didengari mikrofon — penutur dikenal pasti",
    "roomStart": "Mula",
    "statusRoom": "Bilik",
    "roomStrip": "Merakam bilik",
    "roomStrip_aria": "Merakam bilik — semua yang didengari mikrofon",
    "roomOff": "Matikan",
    "roomOff_title": "Matikan mod bilik — ini menjadi nota suara biasa",
    "roomRenameHint": "Ketik satu nama untuk menamakannya semula — salah seorang daripadanya ialah anda.",
    "gateBodyRoom": "Rakam apa yang diperkatakan di sekeliling anda — penutur dikenal pasti dan item tindakan diekstrak. Termasuk dengan Pro.",
    "roomHintDevice": "Panggilan pada peranti ini tidak boleh dirakam — iOS mengekalkannya sebagai peribadi. Telefon lain pada pembesar suara, atau perbualan di dalam bilik, boleh.",
    "autoStoppedSize": "Rakaman berhenti pada had saiz muat naik.",
    "tooLarge": "Rakaman terlalu besar untuk dimuat naik, jadi tidak dapat ditranskripsikan.",
    "destTo": "Ke",
    "dest_aria": "Tambah ke senarai: {{name}}",
    "destMenu_aria": "Pilih senarai",
    "destNewPending_aria": "Senarai baharu: {{name}}"
  },
  "meetingNotice": {
    "title": "Mesyuarat, dalam nota anda",
    "body": "Rhemn kini boleh merakam tab mesyuarat pilihan anda — hanya semasa anda merakam nota suara, dan hanya tab yang anda pilih.",
    "factPrivacy": "Audio diproses untuk menghasilkan transkrip anda, kemudian dibuang. Rakaman tidak pernah disimpan.",
    "factControl": "Tiada apa-apa ditangkap sehingga anda menekan rakam dan memilih tab.",
    "cta": "Faham",
    "privacyLink": "Baca dasar privasi kami",
    "dialog_aria": "Mengenai kebenaran rakaman mesyuarat baharu"
  }
}
